module.exports = __webpack_public_path__ + "img/icon_lottery.436b4c4e.png";